export const FETCH_ORDERED_ORDERS_REQUEST = "FETCH_ORDERED_ORDERS_REQUEST";
export const FETCH_ORDERED_ORDERS_SUCCESS = "FETCH_ORDERED_ORDERS_SUCCESS";
export const FETCH_ORDERED_ORDERS_FAILURE = "FETCH_ORDERED_ORDERS_FAILURE";
